/**
 * O cabeçalho — enxuto, por decisão de 09/10.
 *
 * **Fica na tela em TODAS as visões**: só a metade de baixo alterna entre a
 * grade das 8 divisões e o detalhe de uma delas.
 *
 * O que saiu, e por quê: o relógio, o "atualizado há N s" e o "· Meta 2026"
 * ocupavam altura que a grade precisa — num telão o que importa é o indicador,
 * não o cronômetro.
 *
 * O que FICOU, e por quê: o **ponto pulsante**. Ele é o único sinal de que o
 * painel ainda está vivo, e custa 8 px. Sem nenhum sinal, um painel congelado é
 * indistinguível de um painel em dia — e são quatro dias ligado. Verde pulsando
 * = recebendo; âmbar parado = a conexão caiu. Quando a fonte cai de verdade, o
 * `.alerta-fonte` do dashboard aparece com o texto completo.
 */
import { Alvo, HeaderCamuflado } from './Camuflagem'

type Props = {
  /** ISO da última coleta. `null` = o coletor nunca mandou nada. */
  coletadoEm: string | null
  /** Segundos desde a última coleta, do `usarFluxo`. */
  idadeSeg: number
  /** `false` quando o SSE está fora do ar. */
  conectado: boolean
  /** Marca discreta quando o número da tela é fictício. */
  demonstracao?: boolean
  /** `null` no quiosque do telão: ele não tem caminho para o admin. */
  aoAbrirAdmin: (() => void) | null
  aoSair: () => void
}

export function Cabecalho({
  coletadoEm,
  idadeSeg,
  conectado,
  demonstracao = false,
  aoAbrirAdmin,
  aoSair,
}: Props) {
  const idade = Number.isFinite(idadeSeg) ? Math.max(Math.round(idadeSeg), 0) : null
  const semColeta = coletadoEm === null || idade === null

  /* O texto saiu da tela mas continua no `title` e no `aria-label`: quem chega
     perto, ou usa leitor de tela, ainda descobre de quando é o número. */
  const situacao = semColeta
    ? 'Sem coleta ainda'
    : conectado
      ? `Recebendo — atualizado há ${idade} s`
      : `Sem conexão — último dado de ${idade} s atrás`

  return (
    <header className="cabecalho">
      <HeaderCamuflado />
      <div className="faixa">
        <div className="marca-evento">
          <Alvo />
          <div>
            <div className="titulo-evento">War Room</div>
            <div className="subtitulo-evento">Time Comercial Lunelli</div>
          </div>
        </div>

        <div className="acoes-cabecalho">
          {/* A marca de demonstração, no lugar da faixa que foi retirada. Ela
              não pode sumir de vez: é o que impede alguém de fotografar o telão
              e tratar um número fictício como venda. */}
          {demonstracao && (
            <span className="selo-demonstracao" title="Valores vendidos fictícios; as metas são as reais">
              demonstração
            </span>
          )}

          <span
            className={conectado && !semColeta ? 'pulso' : 'pulso parado'}
            role="img"
            aria-label={situacao}
            title={situacao}
          />

          {/* "Admin" só para quem é admin — `aoAbrirAdmin` é `null` para o resto
              e o botão levaria a um 403. */}
          {aoAbrirAdmin !== null && (
            <button type="button" className="botao" onClick={aoAbrirAdmin}>
              Admin
            </button>
          )}

          {/* "Sair" para TODO MUNDO: o `visualizador` também precisa conseguir
              sair da sessão. */}
          <button type="button" className="botao" onClick={aoSair}>
            Sair
          </button>
        </div>
      </div>
    </header>
  )
}
